









import { defineComponent, PropType, ref } from "@vue/composition-api";
import { ContentSet } from "@scrile/api-provider/dist/api/ContentSetProvider";
import providers from "@/lib/api";
import BaseSwitch from "@/components/BaseSwitch";
import useAutoPostingToX from "@/features/twitterAutoPosting/hooks/useAutoPostingToX";

export default defineComponent({
  name: "AutoPostingToXToggle",
  components: { BaseSwitch },
  props: {
    postData: { type: Object as PropType<ContentSet>, required: true },
  },
  setup(props, { emit }) {
    const { allowSetupAutoPostingInPosts, fetchSettings } = useAutoPostingToX();
    const status = ref(props.postData.twitterAutoPosting);

    const updateTwitterAutoPosting = async () => {
      if (!allowSetupAutoPostingInPosts.value) return;
      await providers.ContentSetProvider.update({
        data: {
          id: props.postData.id,
          twitterAutoPosting: status.value,
        },
      });
    };

    emit("setUpdateCb", updateTwitterAutoPosting);
    fetchSettings();

    return { allowAutoPosting: allowSetupAutoPostingInPosts, status };
  },
});
